import ISelectOption from "../../../models/form-fields/ISelectOption";

const enumToOptionList = <T>(customEnum: T): ISelectOption[] => 
    Object.entries(customEnum).map(e =>  ({text: e[1].label, value:e[1].value}))

const enumHelper = {
    enumToOptionList,
};

export default enumHelper;